"use client";

import React, { useMemo, useState } from "react";
import { Globe, MapPin, Search, Clock, FileText, CreditCard, Zap, Star, ChevronDown } from "lucide-react";
import { Separator } from "@/components/ui/separator";
import { Input } from "@/components/ui/input";
import { ScrollArea } from "@/components/ui/scroll-area";
import { Sheet, SheetContent, SheetDescription, SheetHeader, SheetTitle, SheetTrigger } from "@/components/ui/sheet";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
export const countriesList = [{
  name: "Afghanistan",
  status: "Standard"
}, {
  name: "Albania",
  status: "Premium"
}, {
  name: "Algeria",
  status: "Standard"
}, {
  name: "Andorra",
  status: "Standard"
}, {
  name: "Angola",
  status: "Urgent"
}, {
  name: "Antigua e Barbuda",
  status: "Standard"
}, {
  name: "Arabia Saudita",
  status: "Premium"
}, {
  name: "Argentina",
  status: "Standard"
}, {
  name: "Armenia",
  status: "Standard"
}, {
  name: "Australia",
  status: "Premium"
}, {
  name: "Austria",
  status: "Standard"
}, {
  name: "Azerbaigian",
  status: "Standard"
}, {
  name: "Bahamas",
  status: "Standard"
}, {
  name: "Bahrein",
  status: "Premium"
}, {
  name: "Bangladesh",
  status: "Standard"
}, {
  name: "Barbados",
  status: "Standard"
}, {
  name: "Belgio",
  status: "Standard"
}, {
  name: "Belize",
  status: "Standard"
}, {
  name: "Benin",
  status: "Standard"
}, {
  name: "Bhutan",
  status: "Standard"
}, {
  name: "Bielorussia",
  status: "Standard"
}, {
  name: "Bolivia",
  status: "Standard"
}, {
  name: "Bosnia ed Erzegovina",
  status: "Standard"
}, {
  name: "Botswana",
  status: "Standard"
}, {
  name: "Brasile",
  status: "Premium"
}, {
  name: "Brunei",
  status: "Standard"
}, {
  name: "Bulgaria",
  status: "Standard"
}, {
  name: "Burkina Faso",
  status: "Standard"
}, {
  name: "Burundi",
  status: "Standard"
}, {
  name: "Cambogia",
  status: "Standard"
}, {
  name: "Camerun",
  status: "Standard"
}, {
  name: "Canada",
  status: "Premium"
}, {
  name: "Capo Verde",
  status: "Standard"
}, {
  name: "Ciad",
  status: "Standard"
}, {
  name: "Cile",
  status: "Standard"
}, {
  name: "Cina",
  status: "Premium"
}, {
  name: "Cipro",
  status: "Standard"
}, {
  name: "Colombia",
  status: "Standard"
}, {
  name: "Comore",
  status: "Standard"
}, {
  name: "Congo",
  status: "Standard"
}, {
  name: "Corea del Nord",
  status: "Standard"
}, {
  name: "Corea del Sud",
  status: "Premium"
}, {
  name: "Costa d'Avorio",
  status: "Standard"
}, {
  name: "Costa Rica",
  status: "Standard"
}, {
  name: "Croazia",
  status: "Standard"
}, {
  name: "Danimarca",
  status: "Standard"
}, {
  name: "Dominica",
  status: "Standard"
}, {
  name: "Ecuador",
  status: "Standard"
}, {
  name: "Egitto",
  status: "Premium"
}, {
  name: "El Salvador",
  status: "Standard"
}, {
  name: "Emirati Arabi Uniti",
  status: "Premium"
}, {
  name: "Eritrea",
  status: "Standard"
}, {
  name: "Estonia",
  status: "Standard"
}, {
  name: "Etiopia",
  status: "Standard"
}, {
  name: "Figi",
  status: "Standard"
}, {
  name: "Filippine",
  status: "Standard"
}, {
  name: "Finlandia",
  status: "Standard"
}, {
  name: "Francia",
  status: "Standard"
}, {
  name: "Gabon",
  status: "Standard"
}, {
  name: "Gambia",
  status: "Standard"
}, {
  name: "Georgia",
  status: "Standard"
}, {
  name: "Germania",
  status: "Standard"
}, {
  name: "Ghana",
  status: "Standard"
}, {
  name: "Giamaica",
  status: "Standard"
}, {
  name: "Giappone",
  status: "Premium"
}, {
  name: "Gibuti",
  status: "Standard"
}, {
  name: "Giordania",
  status: "Standard"
}, {
  name: "Grecia",
  status: "Standard"
}, {
  name: "Grenada",
  status: "Standard"
}, {
  name: "Guatemala",
  status: "Standard"
}, {
  name: "Guinea",
  status: "Standard"
}, {
  name: "Guinea-Bissau",
  status: "Standard"
}, {
  name: "Guinea Equatoriale",
  status: "Standard"
}, {
  name: "Guyana",
  status: "Standard"
}, {
  name: "Haiti",
  status: "Standard"
}, {
  name: "Honduras",
  status: "Standard"
}, {
  name: "India",
  status: "Premium"
}, {
  name: "Indonesia",
  status: "Standard"
}, {
  name: "Iran",
  status: "Standard"
}, {
  name: "Iraq",
  status: "Standard"
}, {
  name: "Irlanda",
  status: "Standard"
}, {
  name: "Islanda",
  status: "Standard"
}, {
  name: "Israele",
  status: "Standard"
}, {
  name: "Italia",
  status: "Standard"
}, {
  name: "Kazakistan",
  status: "Standard"
}, {
  name: "Kenya",
  status: "Standard"
}, {
  name: "Kirghizistan",
  status: "Standard"
}, {
  name: "Kiribati",
  status: "Standard"
}, {
  name: "Kuwait",
  status: "Premium"
}, {
  name: "Laos",
  status: "Standard"
}, {
  name: "Lesotho",
  status: "Standard"
}, {
  name: "Lettonia",
  status: "Standard"
}, {
  name: "Libano",
  status: "Standard"
}, {
  name: "Liberia",
  status: "Standard"
}, {
  name: "Libia",
  status: "Standard"
}, {
  name: "Liechtenstein",
  status: "Standard"
}, {
  name: "Lituania",
  status: "Standard"
}, {
  name: "Lussemburgo",
  status: "Standard"
}, {
  name: "Macedonia del Nord",
  status: "Standard"
}, {
  name: "Madagascar",
  status: "Standard"
}, {
  name: "Malawi",
  status: "Standard"
}, {
  name: "Maldive",
  status: "Standard"
}, {
  name: "Malesia",
  status: "Standard"
}, {
  name: "Mali",
  status: "Standard"
}, {
  name: "Malta",
  status: "Standard"
}, {
  name: "Marocco",
  status: "Standard"
}, {
  name: "Mauritania",
  status: "Standard"
}, {
  name: "Mauritius",
  status: "Standard"
}, {
  name: "Messico",
  status: "Standard"
}, {
  name: "Micronesia",
  status: "Standard"
}, {
  name: "Moldavia",
  status: "Standard"
}, {
  name: "Monaco",
  status: "Standard"
}, {
  name: "Mongolia",
  status: "Standard"
}, {
  name: "Montenegro",
  status: "Standard"
}, {
  name: "Mozambico",
  status: "Standard"
}, {
  name: "Myanmar",
  status: "Standard"
}, {
  name: "Namibia",
  status: "Standard"
}, {
  name: "Nauru",
  status: "Standard"
}, {
  name: "Nepal",
  status: "Standard"
}, {
  name: "Nicaragua",
  status: "Standard"
}, {
  name: "Niger",
  status: "Standard"
}, {
  name: "Nigeria",
  status: "Standard"
}, {
  name: "Norvegia",
  status: "Standard"
}, {
  name: "Nuova Zelanda",
  status: "Premium"
}, {
  name: "Oman",
  status: "Premium"
}, {
  name: "Paesi Bassi",
  status: "Standard"
}, {
  name: "Pakistan",
  status: "Standard"
}, {
  name: "Palau",
  status: "Standard"
}, {
  name: "Panama",
  status: "Standard"
}, {
  name: "Papua Nuova Guinea",
  status: "Standard"
}, {
  name: "Paraguay",
  status: "Standard"
}, {
  name: "Perù",
  status: "Standard"
}, {
  name: "Polonia",
  status: "Standard"
}, {
  name: "Portogallo",
  status: "Standard"
}, {
  name: "Qatar",
  status: "Premium"
}, {
  name: "Regno Unito",
  status: "Premium"
}, {
  name: "Repubblica Ceca",
  status: "Standard"
}, {
  name: "Repubblica Centrafricana",
  status: "Standard"
}, {
  name: "Repubblica Democratica del Congo",
  status: "Standard"
}, {
  name: "Repubblica Dominicana",
  status: "Standard"
}, {
  name: "Romania",
  status: "Standard"
}, {
  name: "Ruanda",
  status: "Standard"
}, {
  name: "Russia",
  status: "Premium"
}, {
  name: "Saint Kitts e Nevis",
  status: "Standard"
}, {
  name: "Saint Vincent e Grenadine",
  status: "Standard"
}, {
  name: "Samoa",
  status: "Standard"
}, {
  name: "San Marino",
  status: "Standard"
}, {
  name: "Santa Lucia",
  status: "Standard"
}, {
  name: "São Tomé e Príncipe",
  status: "Standard"
}, {
  name: "Senegal",
  status: "Standard"
}, {
  name: "Serbia",
  status: "Standard"
}, {
  name: "Seychelles",
  status: "Standard"
}, {
  name: "Sierra Leone",
  status: "Standard"
}, {
  name: "Singapore",
  status: "Premium"
}, {
  name: "Siria",
  status: "Standard"
}, {
  name: "Slovacchia",
  status: "Standard"
}, {
  name: "Slovenia",
  status: "Standard"
}, {
  name: "Somalia",
  status: "Standard"
}, {
  name: "Spagna",
  status: "Standard"
}, {
  name: "Sri Lanka",
  status: "Standard"
}, {
  name: "Stati Uniti",
  status: "Premium"
}, {
  name: "Sudafrica",
  status: "Standard"
}, {
  name: "Sudan",
  status: "Standard"
}, {
  name: "Sudan del Sud",
  status: "Standard"
}, {
  name: "Suriname",
  status: "Standard"
}, {
  name: "Svezia",
  status: "Standard"
}, {
  name: "Svizzera",
  status: "Standard"
}, {
  name: "Eswatini",
  status: "Standard"
}, {
  name: "Tagikistan",
  status: "Standard"
}, {
  name: "Taiwan",
  status: "Standard"
}, {
  name: "Tanzania",
  status: "Standard"
}, {
  name: "Thailandia",
  status: "Premium"
}, {
  name: "Timor Est",
  status: "Standard"
}, {
  name: "Togo",
  status: "Standard"
}, {
  name: "Tonga",
  status: "Standard"
}, {
  name: "Trinidad e Tobago",
  status: "Standard"
}, {
  name: "Tunisia",
  status: "Standard"
}, {
  name: "Turchia",
  status: "Premium"
}, {
  name: "Turkmenistan",
  status: "Standard"
}, {
  name: "Tuvalu",
  status: "Standard"
}, {
  name: "Ucraina",
  status: "Standard"
}, {
  name: "Uganda",
  status: "Standard"
}, {
  name: "Ungheria",
  status: "Standard"
}, {
  name: "Uruguay",
  status: "Standard"
}, {
  name: "Uzbekistan",
  status: "Standard"
}, {
  name: "Vanuatu",
  status: "Standard"
}, {
  name: "Vaticano",
  status: "Standard"
}, {
  name: "Venezuela",
  status: "Standard"
}, {
  name: "Vietnam",
  status: "Premium"
}, {
  name: "Yemen",
  status: "Standard"
}, {
  name: "Zambia",
  status: "Standard"
}, {
  name: "Zimbabwe",
  status: "Standard"
}];
export default function CountryVisaDirectory() {
  const [searchQuery, setSearchQuery] = useState("");
  const filteredCountries = useMemo(() => {
    return countriesList.filter(c => c.name.toLowerCase().includes(searchQuery.toLowerCase()));
  }, [searchQuery]);
  const groupedCountries = useMemo(() => {
    const groups: Record<string, typeof countriesList> = {};
    filteredCountries.forEach(country => {
      const letter = country.name.charAt(0).toUpperCase();
      if (!groups[letter]) {
        groups[letter] = [];
      }
      groups[letter].push(country);
    });
    return groups;
  }, [filteredCountries]);
  const sortedLetters = Object.keys(groupedCountries).sort();
  return <section id="countryvisadirectory" className="relative bg-background py-16 md:py-24 overflow-hidden">
      <div className="absolute top-0 right-0 -z-10 h-full w-1/2 opacity-5 pointer-events-none">
        <svg viewBox="0 0 1000 1000" className="h-full w-full fill-secondary">
          <path d="M150,200 Q400,100 600,300 T900,200 L900,800 Q600,900 400,700 T100,800 Z" />
        </svg>
      </div>

      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        
        <div className="mb-8 flex flex-col md:flex-row md:items-end justify-between gap-8">
          <div className="max-w-2xl">
            <div className="mb-4 flex items-center gap-2 text-secondary">
              <Globe className="size-5" />
              <span className="font-sans text-sm font-semibold tracking-wider uppercase">Directory Globale</span>
            </div>
            <h2 className="font-sans text-primary mb-6 text-4xl font-bold tracking-tight md:text-5xl">
              Paesi per Visti Turistici e Consolari
            </h2>
            <p className="text-muted-foreground font-sans text-lg leading-relaxed">
              Esplora il nostro archivio completo di oltre 160 destinazioni. Seleziona un paese per visualizzare i requisiti specifici e i servizi di assistenza dedicati.
            </p>
          </div>
        </div>

        <div className="mb-12 flex items-center justify-end gap-3 animate-pulse">
          <ChevronDown className="size-5 text-secondary" />
          <span className="font-sans text-sm font-bold text-blue-600 uppercase tracking-widest">Scorri per vedere più paesi</span>
        </div>

        <div className="sticky top-0 z-30 bg-background/95 backdrop-blur-sm py-4 mb-12 border-b border-border/40 flex justify-end">
          <div className="relative md:w-96 w-72">
            <Search className="absolute left-4 top-1/2 size-5 -translate-y-1/2 text-muted-foreground z-10" />
            <Input placeholder="Cerca paese..." className="pl-12 h-12 bg-secondary/10 border-blue-600 focus-visible:ring-secondary/50 focus-visible:bg-secondary/15 font-sans text-lg" value={searchQuery} onChange={e => setSearchQuery(e.target.value)} />
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-start">
          <div className="hidden lg:block lg:col-span-5 sticky top-32">
            <div className="relative aspect-square rounded-lg bg-primary/5 border border-secondary/10 flex items-center justify-center overflow-hidden backdrop-blur-sm shadow-xl">
              <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,var(--color-secondary)_0%,transparent_70%)] opacity-10" />
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1663124/img/Gemini_Generated_Image_zhbewyzhbewyzhbe.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1663124/img/Gemini_Generated_Image_zhbewyzhbewyzhbe.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1663124/img/Gemini_Generated_Image_zhbewyzhbewyzhbe.png-wvc-sizes" alt="Global Network" className="w-4/5 h-auto object-cover brightness-150" loading="lazy" />
            </div>
          </div>

          <div className="lg:col-span-7">
            <div className="relative">
              <ScrollArea className="h-[700px] pr-6 bg-primary rounded-xl border border-primary/10">
                <div className="space-y-12 pb-24">
                  {sortedLetters.map((letter, index) => <div key={letter} data-index={index} className="animate-in fade-in slide-in-from-bottom-4 duration-500">
                      <div className="mb-6 flex items-baseline gap-4 sticky top-0 bg-background/95 backdrop-blur-sm py-2 z-10">
                        <h3 className="font-sans text-primary text-4xl font-bold">
                          {letter}
                        </h3>
                        <div className="h-px flex-1 bg-secondary/20"></div>
                      </div>
                      
                      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                        {groupedCountries[letter].map((country, countryIndex) => <Sheet key={country.name}>
                            <SheetTrigger asChild>
                              <button data-index={countryIndex} className="group flex items-center justify-between p-4 rounded-lg border border-secondary/20 bg-secondary hover:bg-secondary/90 transition-all duration-300 text-left shadow-sm">
                                <div className="flex items-center gap-3">
                                  <MapPin className="text-secondary-foreground size-4 opacity-70 group-hover:opacity-100 transition-opacity" />
                                  <span className="font-sans text-base font-semibold text-primary">{country.name}</span>
                                </div>
                              </button>
                            </SheetTrigger>
                            <SheetContent className="w-full sm:max-w-xl bg-background/95 backdrop-blur-xl border-l-secondary/20">
                              <SheetHeader className="mb-8">
                                <div className="flex items-center gap-3 text-secondary mb-2">
                                  <Globe className="size-5" />
                                  <span className="text-xs font-bold uppercase tracking-widest">Dettagli Visto</span>
                                </div>
                                <SheetTitle className="text-3xl font-sans font-bold text-primary">{country.name}</SheetTitle>
                                <SheetDescription className="text-muted-foreground font-sans">
                                  Informazioni aggiornate sui requisiti consolari e tempi di elaborazione per {country.name}.
                                </SheetDescription>
                              </SheetHeader>

                              <div className="space-y-8">
                                <div className="grid grid-cols-1 gap-4">
                                  <div className="p-4 rounded-lg bg-secondary/5 border border-secondary/10">
                                    <div className="flex items-center gap-2 text-secondary mb-1">
                                      <Clock className="size-4" />
                                      <span className="text-xs font-bold uppercase">Tempi</span>
                                    </div>
                                    <div className="text-sm font-sans font-medium space-y-1">
                                      <p>5 Giorni Lavorativi</p>
                                      <p className="text-secondary">Procedura Urgente: 24 ore</p>
                                    </div>
                                  </div>
                                </div>

                                <div>
                                  <h4 className="flex items-center gap-2 text-sm font-bold uppercase tracking-wider text-primary mb-4">
                                    <FileText className="size-4 text-secondary" />
                                    Checklist Documenti
                                  </h4>
                                  <ul className="space-y-3">
                                    {['Passaporto', 'Carta d\'identità', 'Codice fiscale', '4 Fototessere', 'Prenotazione volo', 'Prenotazione hotel', 'Polizza assicurativa'].map((doc, i) => <li key={i} data-index={i} className="flex items-start gap-3 text-sm font-sans text-muted-foreground">
                                        <div className="mt-1.5 size-1.5 rounded-lg bg-secondary shrink-0" />
                                        {doc}
                                      </li>)}
                                  </ul>
                                </div>

                                <Separator className="bg-secondary/20" />

                                <div className="text-sm font-sans text-muted-foreground italic">
                                  I documenti indicati sono base e standard per tutti i visti, il nostro servizio è personalizzato in base alle tue esigenze
                                </div>
                              </div>
                            </SheetContent>
                          </Sheet>)}
                      </div>
                    </div>)}
                </div>
              </ScrollArea>
              <div className="absolute bottom-0 left-0 right-0 h-[120px] bg-gradient-to-t from-background to-transparent pointer-events-none z-20" />
            </div>
          </div>
        </div>

      </div>
    </section>;
}